import { CheckIcon } from "./ProgramSelectorBanner";
import styles from "./ProgramSelectorBanner.module.scss";
import UnivoImage from "@/components/common/UnivoImage";
import { IMAGE_ASSETS } from "@/constants/images";
interface ProgramCardProps {
    program: any;
    selected: boolean;
    onToggle: () => void;
  }
  
export  const ProgramBrandCard: React.FC<ProgramCardProps> = ({ program, selected, onToggle }) => {
    const sponseredImage = program?.attributes?.BasicDetails?.ShortSponsoredImage?.data?.attributes?.url
    const isSponsered = sponseredImage? true:false;
      const feeOptions = program?.attributes?.Fees?.FeesOptions ?? [];
  const fullFee =
    feeOptions.find((f) => f?.Type?.toLowerCase() === "full") ?? feeOptions[0];
  const fee =
    program?.fee ||
    fullFee?.FeesInInr ||
    "";
    const imageData: any =
      (program as any)?.attributes?.BasicDetails?.Image?.source?.data?.[0]?.attributes;
    const imageUrl = imageData?.url || "";
    const imageAlt =
      imageData?.alternativeText ||
      (program as any)?.attributes?.BannerSlider?.Heading?.text ||
      "Program";
    return (
      <div className={`${styles.cardRow} ${selected ? styles.cardRowActive : ""}`}>
        <button
          type="button"
          className={`${styles.cardCheckbox} ${selected ? styles.cardCheckboxOn : ""}`}
          onClick={onToggle}
          aria-pressed={selected}
          aria-label={selected ? `Deselect ${program.title}` : `Select ${program.title}`}
        >
          {selected && <CheckIcon className={styles.cardCheckIcon} />}
        </button>
  
        <div className={styles.card}>
          <div className={styles.cardImage}>
            {imageUrl && (
              <UnivoImage
                src={imageUrl}
                alt={imageAlt}
                width={280}
                height={160}
                sizes="280px"
                loading="lazy"
                fetchPriority="low"
                className={styles.cardImageEl}
              />
            )}
        {
          isSponsered && (
            <div className={styles.sponsoredBadge}>
              <span className={styles.sponsoredText}>In Collaboration with</span>
              <UnivoImage
                src={sponseredImage}
                alt="Sponsored"
                className={styles.sponsoredLogo}
                width={80}
                height={24}
                sizes="80px"
                loading="lazy"
                fetchPriority="low"
              />
            </div>
          )
        }
          </div>
          <div className={styles.cardBody}>
            <p className={styles.cardTitle}>{program?.attributes?.BannerSlider?.Heading?.text}</p>
            <div className={styles.cardMeta}>
              <span className={styles.cardMetaItem}>
                <UnivoImage
                  src={IMAGE_ASSETS.watchIcon}
                  height={20}
                  width={20}
                  alt=""
                  sizes="20px"
                  loading="lazy"
                  fetchPriority="low"
                /> {program?.duration}
              </span>
              <span className={styles.cardMetaItem}>
                <UnivoImage
                  src={IMAGE_ASSETS.amountIcon}
                  height={20}
                  width={20}
                  alt=""
                  sizes="20px"
                  loading="lazy"
                  fetchPriority="low"
                /> {fee}
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
export  const CertificationCard: React.FC<ProgramCardProps> = ({ program, selected, onToggle }) => {
    const sponseredImage = program?.attributes?.BasicDetails?.ShortSponsoredImage?.data?.attributes?.url
    const isSponsered = sponseredImage? true:false;
    const imageData: any =
      (program as any)?.attributes?.BasicDetails?.Image?.source?.data?.[0]?.attributes;
    const imageUrl = imageData?.url || "";
    const imageAlt =
      imageData?.alternativeText ||
      (program as any)?.attributes?.BasicDetails?.Heading ||
      "Certificate";
    return (
      <div className={`${styles.cardRow} ${selected ? styles.cardRowActive : ""}`}>
        <button
          type="button"
          className={`${styles.cardCheckbox} ${selected ? styles.cardCheckboxOn : ""}`}
          onClick={onToggle}
          aria-pressed={selected}
          aria-label={selected ? `Deselect ${program.title}` : `Select ${program.title}`}
        >
          {selected && <CheckIcon className={styles.cardCheckIcon} />}
        </button>
  
        <div className={styles.card}>
          <div className={styles.cardImage}>
            {imageUrl && (
              <UnivoImage
                src={imageUrl}
                alt={imageAlt}
                width={280}
                height={160}
                sizes="280px"
                loading="lazy"
                fetchPriority="low"
                className={styles.cardImageEl}
              />
            )}
             {
          isSponsered && (
            <div className={styles.sponsoredBadge}>
              <span className={styles.sponsoredText}>In Collaboration with</span>
              <UnivoImage
                src={sponseredImage}
                alt="Sponsored"
                className={styles.sponsoredLogo}
                width={80}
                height={24}
                sizes="80px"
                loading="lazy"
                fetchPriority="low"
              />
            </div>
          )
        }
          </div>
          <div className={styles.cardBody}>
            <p className={styles.cardTitle}>{program?.attributes?.BasicDetails?.Heading}</p>
            <div className={styles.cardMeta}>
              <span className={styles.cardMetaItem}>
                <UnivoImage
                  src={IMAGE_ASSETS.watchIcon}
                  height={20}
                  width={20}
                  alt=""
                  sizes="20px"
                  loading="lazy"
                  fetchPriority="low"
                /> {program?.attributes?.BasicDetails?.Fees?.[1]?.Subheading }
              </span>
              <span className={styles.cardMetaItem}>
                <UnivoImage
                  src={IMAGE_ASSETS.amountIcon}
                  height={20}
                  width={20}
                  alt=""
                  sizes="20px"
                  loading="lazy"
                  fetchPriority="low"
                />{""}
                 <span
                  dangerouslySetInnerHTML={{
                    __html: program?.attributes?.BasicDetails?.Fees?.[4]?.Heading || program?.attributes?.BasicDetails?.Fees?.[0]?.feesInINR,
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    );
  };
